window.addEventListener('DOMContentLoaded', (event) => {
	// This is the file to search the DOM text nodes for Glossary terms and wrap them in the spans their little hearts desire
	// where are we searching in
	const targetRoot = document.querySelector('.single-guide main#main');
	// List all the sections that we wil NOT highlight items in
	const aftermetooExclusionSelectors = [
		// opt-out wrapper: wrap text in <span class="no-glossary">…</span> to skip highlighting
		'.no-glossary',
		// do not highlight on the glossary listing page
		'.post-type-archive-glossary *',
		// Ignore several section on the page that are not content we care about
		'.article-header',
		'.callout-tip',
		'.article-share',
		'.article-nav',
		'.helpful',
		'.report',
		'.survivor-story__related',
		// Ignore several element types
		'table',
		'button',
		'a',
		'h1',
		'h2',
		'h3',
		'h4',
		'h5',
		'h6',
	];
	const allTextNodes = recursivelyGetAllTextNodes(
		targetRoot,
		aftermetooExclusionSelectors
	);
	// const allTextNodes = recursivelyGetAllTextNodes();
	// Now we have the text nodes to search... let's search em'
	highlightTermsInTextNodes(window.glossary_terms, allTextNodes);
});

/**
 * Search text nodes for sub strings and add wrapper spans to them
 * @param {Object[]} terms - An array of terms to find in the nodes.
 * @param {string} terms.t - The string term to search for.
 * @param {string} terms.d - The description of the term for the highlight tooltip.
 * @param {int} terms.l - The limit of how many times the located term should be highlighted.
 * @param {string[]} terms.s - An array of synonyms that can also be used for the match.
 * @param {int[]} terms.e - An array of post IDs where this term should be excluded from being matched.
 * @param {Node[]} textNodes - An array of text nodes to case insensitively search for terms.
 */

function highlightTermsInTextNodes(terms = [], textNodes = []) {
	// This will look through every text node, in order and then compare the text against every term and synonym, in order
	// Keep count of matches so that we can stay within the limits
	const matchedTerms = {};
	// Get the current POST id so that we can ensure that nothing is matching that is disallowed
	let currentPostID = document.body.dataset?.postId;
	currentPostID = currentPostID === undefined ? 0 : Number(currentPostID);
	// zero out all counts and remove excluded terms
	terms = terms.filter((term) => {
		matchedTerms[term.t.trim().toLowerCase()] = { matches: 0 };
		const excludedPostIds = term.e;
		if (
			excludedPostIds instanceof Array &&
			excludedPostIds.some((epi) => epi === currentPostID)
		) {
			// we have matched a post ID we want to ignore.  continue to the next term
			return false;
		}
		return true;
	});
	// create a for loop so that new additions will still be processed
	for (let i = 0; i < textNodes.length; i++) {
		// compare the text against every term and synonym, in order
		const currentNode = textNodes[i];
		terms.forEach((term) => {
			// get an array of the term and all it's synonyms
			const termAndSynonyms = [term.t, ...term.s];
			// get the limit of the term
			const limit = Number(term.l);
			termAndSynonyms.forEach((searchTerm) => {
				// If a match is found the text will be wrapped in a span to highlight it and add a tooltip.
				const text = currentNode.textContent.toLowerCase();
				// normalize the text
				const searchText = searchTerm.trim().toLowerCase();
				const matchBounds = [];
				const match = text.indexOf(searchText);
				if (match >= 0) {
					// We have a winner!
					// set the bounds of the match to the start of the found text and the end of it
					matchBounds[0] = match;
					matchBounds[1] = match + searchText.length;
					// let's check that it's a FULL match and not a partial match
					// we do that by looking just before and after to ensure the surrounding characters are not word characters
					// assume that it matches and flip to false if not
					let fullMatch = true;
					// look ahead
					if (matchBounds[0] > 0) {
						const checkText = text.substring(
							matchBounds[0] - 1,
							matchBounds[0]
						);
						if (checkText.match(/\w/)) {
							fullMatch = false;
						}
					}
					// look past
					if (matchBounds[1] < text.length - 1) {
						const checkText = text.substring(
							matchBounds[1],
							matchBounds[1] + 1
						);
						if (checkText.match(/\w/)) {
							fullMatch = false;
						}
					}
					if (!fullMatch) {
						// We did not match a full word to this term.  exit out of the callback checking this term
						return;
					}
					// check that we're not over the limit for this term / synonym
					if (
						matchedTerms[term.t.trim().toLowerCase()].matches >=
						limit
					) {
						// Sorry, seat's taken
						return;
					}
					matchedTerms[term.t.trim().toLowerCase()].matches++;

					// Split the textNode at the bounds
					// the remaining text in the text node that does NOT match will be split into a new textNode and pushed onto to the end of the array
					// to get processed for other matches later
					const remainingTextNode = currentNode.splitText(
						matchBounds[1]
					);
					textNodes.push(remainingTextNode);
					// Create a new text node of the matched content that will be added to spans and such
					const matchedTermTextNode = currentNode.splitText(
						matchBounds[0]
					);
					// create the highlight DOM innerHTML
					const templateString = `
							<button aria-expanded="false"></button>
							<span class="tooltip" role="tooltip" id="${term.n}">
								<strong>${term.t}</strong><br />
								<div class="tooltip__content">${term.d}</div>
								<a href="${window.glossary_link}#${term.n}" class="view">${window.glossary_strings.view_label}</a>
								<button class="close" aria-label="${window.glossary_strings.close_label}"></button>
							</span> `;
					const highlightSpan = document.createElement('span');
					highlightSpan.classList.add('highlight');
					// Insert the new span
					matchedTermTextNode.parentNode.insertBefore(
						highlightSpan,
						matchedTermTextNode
					);
					highlightSpan.innerHTML = templateString;
					const highlightButton =
						highlightSpan.querySelector('button');

					// Add the matchedText to the span
					highlightButton.appendChild(matchedTermTextNode);
				}
			});
		});
	}
	// We have now added all the highlights and set the DOM let's trigger tooltip JS
	window.dispatchEvent(new Event('aftermetoo_glossary_ready'));
}

/**
 * Get All text nodes that are descendants of a given root node optionally filtered by an array of CSS selectors.
 * @param {Node} rootNode - The DOM element to get the text nodes from.
 * @param {string[]} exclusionSelectors - An array of strings that are CSS selectors that will be used to exclude nodes and their children from being returned.
 */

function recursivelyGetAllTextNodes(
	rootNode = document.body,
	exclusionSelectors = []
) {
	// First thing is first. Check that our root node even matches an actual node
	if (!Boolean(rootNode?.nodeType) || rootNode.nodeType !== 1) {
		// In any of these cases we cannot continue. we do not have a valid root node.
		return [];
	}
	// we have some base level exclusion selectors we simply can't ignore because of what we intend to do with these text nodes
	const mandatoryExclusionSelectors = [
		'meta',
		'script',
		'noscript',
		'svg',
		'option',
		'input',
	];
	// These need to be merged with the exclusion selectors passed in by the method invocation. We need to create a set so that we do not have duplicates.
	// Because this is a recursive function we don't want to be adding on these mandatory selectors every single time and increasing the memory space of the method
	const targetExclusionSelectors = [
		...new Set([...mandatoryExclusionSelectors, ...exclusionSelectors]),
	];
	// Start with an empty array to hold all of the text nodes
	let textNodes = [];
	// get all child nodes of the rootNode
	let children = [...rootNode.childNodes];
	// check each one is either a non-empty text node (nodeType === 3) or an element node that is NOT excluded
	children = children.filter(
		(childNode) =>
			(childNode.nodeType === 3 &&
				childNode.textContent.trim().length > 0) ||
			(childNode.nodeType === 1 &&
				targetExclusionSelectors.every(
					(sel) => !childNode.matches(sel)
				))
	);
	// now loop through the filtered children and
	children.forEach((child) => {
		// if they are a text node add them to the list
		if (child.nodeType === 3) {
			// if so add to the list
			textNodes.push(child);
			// Done processing node, return
			return;
		}
		// if not pass it to this recursive function
		textNodes = [
			...textNodes,
			...recursivelyGetAllTextNodes(child, targetExclusionSelectors),
		];
	});
	// return the text nodes
	return textNodes;
}
